<alaris-dialog
	[closeAction]="close.bind(this)"
	[confirmAction]="confirm.bind(this)"
	[loading$]="service.loading$"
	[confirmButtonText]="'gl.delete'"
	size="md"
	class="removingDialog">
	<h3 slot="header">
		<app-circle-warning></app-circle-warning>
		<div>
			{{ 'system_codes.removingDialogTitle' | translate }}
		</div>
	</h3>
	<div slot="content">
		<p>
			{{ 'system_codes.removing_dialog' | translate }}
			<strong>{{ data.code.id }}</strong>
			@if(rules.length > 0) {
			<hr class="divider" />
			<span>{{ 'system_codes.removing_rules' | translate }}</span>
			<hr />
			@for(rule of rules; track rule) {
			<span>
				<strong>{{ 'ID: ' + rule.id + '\n' + 'Name: ' + rule.name }}</strong>
			</span>
			} }
		</p>
	</div>
</alaris-dialog>
